import React, { useState, useEffect, useCallback } from 'react'
import { Heading, Table, Button, TextInput, toaster, Text, Strong, Switch } from 'evergreen-ui';
import { connect } from 'react-redux';
import { setLoading, unsetLoading } from '../../../Redux/reducers/loading';
import axios from '../../../Utils/axios';
import ToggleWeek from '../../../Components/ToggleWeek';

const TimeClock = ({
    dispatch
  }) => {
  const [ days, setDays ] = useState([]); 
  const [ active, setActive ] = useState(false);
  const [ hours, setHours ] = useState([]);
  const [ hour, setHour ] = useState("");
  const [ isLoaded, setIsLoaded] = useState(false);

  const save = useCallback(async () => {
    try {
      await axios.post(`/company/timeclock`, {
        active,
        days: active ? days : [],
        hours: active ? hours : []
      })
    }
    catch (error) {
      if (error.response) {
        toaster.danger(error.response.data.error.message)
      }
      else {
        toaster.danger('Falha na comunicação com o servidor')
      }
    }
  }, [active, days, hours])

  const getTimeClock = useCallback(async () => {
    setIsLoaded(false);
    dispatch(setLoading())
    try {
      const { data } = await axios.get(`/company/timeclock`)
      setActive(data.active);
      setHours(data.hours);
      setDays(data.days);
      setIsLoaded(true);
    }
    catch (error) {
      toaster.danger('Falha ao buscar dados')
    }
    finally {
      dispatch(unsetLoading())
    }
  }, [dispatch])

  function handleDayChange(index, include) {
    if (include) {
        setDays([...days, index]);
    } else {
        setDays(days.filter(day => day !== index))
    }
  }

  useEffect(() => {
      getTimeClock();
  }, [getTimeClock]);

  useEffect(() => {
      if (isLoaded) {
          save();
      }
  }, [hours, active, days, isLoaded, save]);

  const handleRemoveHour = (hour) => {
      setHours(hours.filter(item => item !== hour));
  }

  const handleAddHour = () => {
      if (!hour) {
          return toaster.danger('Hora inválida!');
      }   
      if (hours.includes(hour)) {
          return toaster.danger('Hora ' + hour + ' já cadastrada!');
      }
      hours.push(hour);
      setHours([...hours.sort()]);
      setHour("");
  }

  function handleActive(activate) {
      if (!activate) {
          setHours([]);
          setDays([]);
      }
      setActive(activate)
  }

  const renderActive = () => (
    <>
      <Heading size={600}>
          Configuração de Ponto
      </Heading>
      <div>
        <Text>Trabalha com registro ponto</Text>
        <Switch
          name='active'
          height={24}
          checked={active}
          onChange={() => handleActive(!active) }
          marginBottom={16}
        />
      </div>
    </>
  )

  if (!active) {
    return (
      renderActive()
    )
  }

  return (
    <div>
      { renderActive() }
      <div>
          <Strong size={600} marginTop="default">Dias da semana com solicitação de ponto</Strong>
      </div>
      <ToggleWeek days={days} handleDayChange={handleDayChange}/>
      <div>
          <Heading size={600}>
            Horários de alerta
          </Heading>
          <TextInput
            marginRight={10}
            name="time"
            placeholder="Adicionar hora..."
            type="time"
            width="50"
            value={hour}
            onChange={({target}) => setHour(target.value)} />
            <Button 
            appearance="primary"
            onClick={() => handleAddHour()}
          >Adicionar</Button>
      </div>
      <Table style={{ marginTop: 15 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Hora
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={600}>
          { hours.map(item => (
            <Table.Row key={item}>
                <Table.TextCell>{item}</Table.TextCell>
                <Table.TextCell >
                <Button
                    iconBefore='edit'
                    marginRight={20}
                    onClick={() => handleRemoveHour(item)}
                > Remover </Button>
                </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>
      </Table>
    </div>
  );
}

export default connect()(TimeClock);
